import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import vi from 'element-plus/es/locale/lang/vi'
import en from 'element-plus/es/locale/lang/en'
import i18n from '@/lang/'
import moment from 'moment'
import { getStorage } from "@/utils/storage";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import "@/static/styles/common.scss";
import 'element-plus/theme-chalk/index.css';

import componentsModules from './components';

//初始化app
let app = createApp(App)
app.config.globalProperties.moment = moment
app.use(store)
app.use(i18n)
const language = getStorage("language") || "zh";
app.use(ElementPlus, {
  locale: language == 'zh' ? zhCn : language == 'vn' ? vi : en,
  i18n: (key, value) => i18n.t(key, value),
});
app.use(router)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

for (const [key, component] of Object.entries(componentsModules)) {
  app.component(key, component)
}

router.isReady().then(() => app.mount('#app'))

